module.exports = __webpack_public_path__ + "img/1970East-006_WEB-min.78f440fa.jpg";